import { ChevronLeft, ChevronRight, RefreshCw } from 'lucide-react';

interface FileNavigationControlsProps {
  canGoBack: boolean;
  canGoForward: boolean;
  onBack: () => void;
  onForward: () => void;
  onRefresh: () => void;
  isLoading?: boolean;
}

export function FileNavigationControls({
  canGoBack,
  canGoForward,
  onBack,
  onForward,
  onRefresh,
  isLoading = false,
}: FileNavigationControlsProps) {
  return (
    <div className="flex items-center space-x-1">
      <button
        onClick={onBack}
        disabled={!canGoBack}
        className={`p-2 rounded-md transition-colors duration-200 ${
          canGoBack
            ? 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
            : 'text-gray-300 dark:text-gray-600 cursor-not-allowed'
        }`}
        aria-label="Go back"
        data-ph-capture-attribute="btn-file-nav-back"
      >
        <ChevronLeft className="h-5 w-5" />
      </button>

      <button
        onClick={onForward}
        disabled={!canGoForward}
        className={`p-2 rounded-md transition-colors duration-200 ${
          canGoForward
            ? 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
            : 'text-gray-300 dark:text-gray-600 cursor-not-allowed'
        }`}
        aria-label="Go forward"
        data-ph-capture-attribute="btn-file-nav-forward"
      >
        <ChevronRight className="h-5 w-5" />
      </button>

      <button
        onClick={onRefresh}
        className={`p-2 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 ${
          isLoading ? 'animate-spin' : ''
        }`}
        aria-label="Refresh"
        data-ph-capture-attribute="btn-file-nav-refresh"
      >
        <RefreshCw className="h-5 w-5" />
      </button>
    </div>
  );
}
